import React,{useRef,useEffect,useState} from 'react';
import {useDispatch,useSelector} from 'react-redux';
import {userActions} from '../../../actions/user.actions'
import 'moment-timezone';
import moment from 'moment';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import createpayment from '../../../assets/images/createmanual.png'
import TextField from '@mui/material/TextField';
import './index.css'
import close from "../../../assets/images/close.png"
import Datetime from 'react-datetime'; 
import {Input} from 'reactstrap'
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

const style = {
   
   
  justifyContent: 'center',
  width: 600,
  bgcolor: 'background.paper',
  height:'auto',
  overflowY: 'scroll',
  boxShadow: 20,
  borderRadius:2,
  marginTop:'2em',
  marginBottom:'2em'
   
  
};



export default function ManualPayment({totalEmiAmount,selectedItems,chequeBounceCharges,overdueCharges,interest,userId,remainingAmount,legalCharges,isPreClosure,discountedBounce,discountedPenalty,principleAmount,paidBounce,paidPenalty,paidPrinciple,paidInterest,principle}) {
  const [open, setOpen] = React.useState(false);
  const user=sessionStorage.getItem('user')
  const uploadState=useSelector((state)=>state?.uploadFile?.res?.data?.data)
  React.useEffect(() => {
    
    if(uploadState)
    {
      setProof(uploadState?.s3Url)
    }
  
    
  }, [uploadState])

  console.log("isPreClosure--->",isPreClosure,totalEmiAmount)
  
  const handleOpenDialog=()=>{
      setOpen(true)
      setEmiReceivedAmount("");
      setReceivedBounceCharges("");
      setReceivedPenalty("");
      setReceivedLegalCharges("");
      setEmiAmountDiscount("");
      setBounceChargesDiscount("");
      setPenaltyDiscount("");
      setLegalChargesDiscount("");
      setAdjustmentAmount(null);
      setTransactionId(null);
      setSelectedDate(null);
      setReasonCode("Select");
      setBank("Select")
      setValueRadio('A/C Transfer');
      setProof(null);
      const initialEmiAmount =
  principle + interest - (paidPrinciple + paidInterest) - emiAmountDiscount;
  setEmiReceivedAmount(isPreClosure ? totalEmiAmount : initialEmiAmount);
     
  }
  

    const dispatch=useDispatch();

  const uploadRef=useRef()
  const openProofUpload=()=>{
  uploadRef.current.click()
  
}

const [valueRadio, setValueRadio] = React.useState('A/C Transfer');

  const handleChange = (event) => {
    setValueRadio(event.target.value);
  };
const [proof,setProof]=React.useState(null)

const handleProofUpload=(event)=>{
   
 const body=new FormData();
 body.append("file",event.target.files[0]);
 body.append("type",'transaction_proof');
     
  
  const urlUpload='/file/upload'
  
  dispatch(userActions.uploadFile(urlUpload,body))
}

const [maxDiscount,setMaxDiscount]=useState(0)
useEffect(() => {
  const discount = Math.round((principleAmount * 2) / 100);
  setMaxDiscount(discount)
}, [principleAmount]);

console.log("maxDiscount",maxDiscount)
 
const [transactionId,setTransactionId]=React.useState(null)
const [receivedEmiAmount,setEmiReceivedAmount]=React.useState("")
const [receivedBounceCharges,setReceivedBounceCharges]=React.useState("")
const [receivedPenalty,setReceivedPenalty]=React.useState("")
const [receivedLegalCharges,setReceivedLegalCharges]=React.useState("")
const [emiAmountDiscount,setEmiAmountDiscount]=React.useState("")
const [bounceChargesDiscount,setBounceChargesDiscount]=React.useState("")
const [penaltyDiscount,setPenaltyDiscount]=React.useState("")
const [legalChargesDiscount,setLegalChargesDiscount]=React.useState("")
const [adjustmentAmount,setAdjustmentAmount]=React.useState(null)
const [selectedDate,setSelectedDate]=React.useState(null)
const [reasonCode,setReasonCode]=React.useState("Select")
const [bank,setBank]=React.useState("Select")

console.log("principle",principle)
console.log("interest",interest)
console.log("paidPrinciple",paidPrinciple)
console.log("paidInterest",paidInterest)
console.log("receivedEmiAmount",receivedEmiAmount)

const handleEmiAmount=(event)=>{
  setEmiReceivedAmount(event.target.value);
}

const handleClose = () => {
  setOpen(false);
  setEmiReceivedAmount("");
  setReceivedBounceCharges("");
  setReceivedPenalty("");
  setReceivedLegalCharges("");
  setEmiAmountDiscount("");
  setBounceChargesDiscount("");
  setPenaltyDiscount("");
  setLegalChargesDiscount("");
  setAdjustmentAmount(null);
  setTransactionId(null);
  setSelectedDate(null);
  setReasonCode("Select");
  setBank("Select")
  setValueRadio('A/C Transfer');
  setProof(null);
};
    const formattedDate = selectedDate?.toLocaleString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });
var date = new Date(formattedDate);
var year = date.getFullYear();
var month = ('0' + (date.getMonth() + 1)).slice(-2); 
var day = ('0' + date.getDate()).slice(-2);

var date = year + '-' + month + '-' + day;


const generateReceipt=()=>{
  const urlGenerateReceipt='/loan-repayment/manual-repayment'
  if(emiAmountDiscount > maxDiscount){
    alert(`Emi Discount should not be more than ${maxDiscount}`)
  }else{
    const body={
      userId:userId,
      loanId: sessionStorage.getItem('legacyLoanId'),
      // legacyLoanId: sessionStorage.getItem('legacyLoanId'),
      emiIds:selectedItems,
      transactionId: transactionId?.trim(),
      // transactionProofUrl: proof,
      repaymentId: "string",
      paymentAmount:Number(receivedEmiAmount),
      // paymentAmount:receivedEmiAmount?(Number(receivedEmiAmount)(chequeBounceCharges-discountedBounce-bounceChargesDiscount-paidBounce) + (overdueCharges-discountedPenalty-penaltyDiscount-paidPenalty)):(Number(Number((principle+interest-(paidPrinciple-paidInterest)))-Number(emiAmountDiscount)) + (chequeBounceCharges-discountedBounce-bounceChargesDiscount-paidBounce) + (overdueCharges-discountedPenalty-penaltyDiscount-paidPenalty)),
      paymentMode: valueRadio==="A/C Transfer"?3:valueRadio==="UPI"?2:1,
      paidAt: date ,
      manualPaymentReason:Number(reasonCode),
      bank:Number(bank),
      bounceDiscount: Number(bounceChargesDiscount),
      penaltyDiscount: Number(penaltyDiscount),
    }
    console.log("dataaaaaaaaaa",body)
    dispatch(userActions.generateManualPaymentReceipt(urlGenerateReceipt,user,body))
  }
  
}


function formatNumberWithCommas(number) {
  return number?.toLocaleString('en-IN'); 
}
const [error, setError] = useState("");


const isSpanClickable = selectedItems.length>=1;
  return (
    <>
      <span onClick={isSpanClickable?() => handleOpenDialog():null} style={{cursor: isSpanClickable?'pointer':"not-allowed",border:'1px solid #D0D0D0',borderRadius: '10px', paddingRight:'10px',boxShadow:'0px 0px 1px 1px #F0F0F0',fontWeight:'bold',color:'#344054'}}>
        <img src={createpayment}  style={{paddingLeft:'15px'}}/> Create Manual Payment
      </span>
      <Modal
        open={open}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{display:'flex',justifyContent:'center'}}
      >
        <Box sx={style}>
          <Typography style={{borderTopLeftRadius:'8px',borderTopRightRadius:'8px',backgroundColor:'#F0F0F0' ,borderBottom:'1px solid #D0D0D0',display:'flex',justifyContent:'space-between',paddingLeft:'2%',paddingRight:'2%'}}      >
           <p style={{fontSize:'20px',paddingTop:'10px',fontWeight:'bold'}}> Manual Payment Update </p>
            <img src={close} style={{cursor:'pointer',height:'1.5rem',marginTop:'1em'}} onClick={() => {setOpen(!open);window.location.reload()}}/>
          
          </Typography>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Total Emi Amount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={(principle+interest-(paidPrinciple-paidInterest))} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Amount Received"  variant="outlined" type='number'  InputLabelProps={{style: { fontSize: '12px' }}} value={receivedEmiAmount} onChange={handleEmiAmount}/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Emi Amount Discount"  variant="outlined"  InputLabelProps={{style: { fontSize: '12px' }}} value={emiAmountDiscount} onChange={(event)=>{setEmiAmountDiscount(event.target.value)}}  disabled={!isPreClosure}/>
          </Grid>
          </Grid>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Total Bounce Charges" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={(chequeBounceCharges-discountedBounce-paidBounce)} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Bounce Chrgs Recvd" variant="outlined"  InputLabelProps={{style: { fontSize: '12px' }}} value={(chequeBounceCharges-discountedBounce-bounceChargesDiscount-paidBounce)} onChange={(event)=>{setReceivedBounceCharges(event.target.value)}}/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Bounce Chrgs Discnt" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={bounceChargesDiscount} onChange={(event)=>{setBounceChargesDiscount(event.target.value)}}/>
          </Grid>
          </Grid>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Total Penlty" variant="outlined" InputLabelProps={{style: { fontSize: '12px' },shrink: true}} value={(overdueCharges-discountedPenalty-paidPenalty)} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Penlty Received" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={(overdueCharges-discountedPenalty-penaltyDiscount-paidPenalty)} onChange={(event)=>{setReceivedPenalty(event.target.value)}}/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Penlty Discount" variant="outlined" InputLabelProps={{style: { fontSize: '12px' }}} value={penaltyDiscount} onChange={(event)=>{setPenaltyDiscount(event.target.value)}}/>
          </Grid>
          </Grid>
          {/* <p style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',paddingLeft:'10px',fontWeight:'600',paddingTop:'10px' }}>Legal Charges: </p> */}
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" marginTop="10px">
          <Grid item xs={4}>
          <TextField label="Legal Charges" variant="outlined" InputLabelProps={{style: { fontSize: '12px'},shrink: true}} value={legalCharges} disabled/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Legal Chrgs Received" variant="outlined" InputLabelProps={{style: { fontSize: '12px'}}} value={receivedLegalCharges} onChange={(event)=>{setReceivedLegalCharges(event.target.value)}}/>
          </Grid>
          <Grid item xs={4}>
          <TextField label="Legal Chrgs Discount" variant="outlined" InputLabelProps={{style: { fontSize: '12px'}}} value={legalChargesDiscount} onChange={(event)=>{setLegalChargesDiscount(event.target.value)}}/>
          </Grid>
          </Grid>
          <p style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',paddingLeft:'10px',fontWeight:'500',paddingTop:'10px' }}>Mode Of Payment: </p>
          <div style={{display:'block',marginBottom:'0.5em',paddingLeft:'10px',paddingRight:'10px'}}>
          <RadioGroup  
          style={{display:'flex',flexDirection: 'row',justifyContent: 'space-between',}}
              aria-labelledby="demo-controlled-radio-buttons-group"
              name="controlled-radio-buttons-group"
              value={valueRadio}
              onChange={handleChange}
            >
              <FormControlLabel value="A/C Transfer" control={<Radio />} label={<span style={{ fontFamily: 'Inter-Medium', fontSize: '14px',color:'gray' }}>A/C Transfer</span>} />
              <FormControlLabel value="Cheque" control={<Radio />} label= {<span style={{ fontFamily: 'Inter-Medium', fontSize: '14px' ,color:'gray'}}>Cheque</span>}/>
              <FormControlLabel value="UPI" control={<Radio />} label= {<span style={{ fontFamily: 'Inter-Medium', fontSize: '14px' ,color:'gray'}}>UPI</span>} />
           </RadioGroup>
           
          </div>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px">
          <Grid item xs={6}>
          <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Select Category</Typography>

          <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select" onChange={(e)=>setReasonCode(e.target.value)} value={reasonCode} style={{border:'none',fontSize:'14px',color:'gray'}}
            >
              <MenuItem value="Select">Select</MenuItem>
              <MenuItem value={1}>Preclosure</MenuItem>
              <MenuItem value={2}>Overdue</MenuItem>
              <MenuItem value={3}>Single EMI payment</MenuItem>
              <MenuItem value={4}>Multiple EMIs</MenuItem>
              <MenuItem value={5}>Settlement</MenuItem>
              <MenuItem value={6}>Refund By Institute</MenuItem>
            </Select>
          </FormControl>
        </Box>          
          </Grid>
          <Grid item xs={6}>
          <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Select Bank</Typography>

          <Box sx={{ minWidth: 120 }}>
          <FormControl fullWidth>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select" onChange={(e)=>setBank(e.target.value)} value={bank} style={{border:'none',fontSize:'14px',color:'gray'}}
            >
              <MenuItem value="Select">Select</MenuItem>
              <MenuItem value={1}>KOTAK MAHINDRA BANK</MenuItem>
              <MenuItem value={3}>DIGIO</MenuItem>
              <MenuItem value={2}>RAZORPAY REPAYMENTS</MenuItem>
              <MenuItem value={4}>RBL</MenuItem>
            </Select>
          </FormControl>
        </Box>  
          </Grid>
          </Grid>
          <Grid container spacing={2} paddingLeft="10px" paddingRight="10px" paddingTop="10px">
          <Grid item xs={6}>
          <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }}>Paid Date</Typography>
          <Datetime
              id="fromDate"
              dateFormat="YYYY/MM/DD"
              timeFormat={false}
              onChange={(date) => setSelectedDate(moment.isMoment(date) ? date.format('YYYY/MM/DD') : null)}
              locale="en-gb"
              closeOnSelect={true}
              inputProps={{ placeholder: 'Paid Date',style:{fontFamily:'Inter-Medium',fontSize:'14px',height:'4em',borderColor:'#D3D3D3',borderRadius:'5px'} }}
            />          
          </Grid>
          <Grid item xs={6}>
            <Typography gutterBottom style={{fontFamily:'Inter-Medium',fontSize:'14px',marginBottom:'-3px',fontWeight:'500' }} >Transaction ID</Typography>
          <TextField placeholder='Transaction Id' variant="outlined" InputLabelProps={{style: { fontSize: '14px',border:'none' }}} style={{width:"100%"}} onChange={(e)=>setTransactionId(e.target.value)}/>
          </Grid>
          </Grid>
          <Grid container display="flex" justifyContent="center" paddingBottom="15px">
            <Grid item>
              <Button style={{backgroundColor:'#D32028',marginTop:'2rem',color:'white'}} onClick={()=>generateReceipt()}>SUBMIT</Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </>
  );
}